import React from 'react';

const getLayoutClassName = () => 'grid grid-cols-[repeat(auto-fill,minmax(165px,1fr))] gap-1';

const ProductGrid = ({ className = '', children }) => (
  <div className={`${getLayoutClassName()} ${className}`.trim()}>{children}</div>
);

export default ProductGrid;
